const columns = [
  {
    name: 'Festival/Event Name',
    selector: (row) => row.festName,
  },
  {
    name: 'Actions',
    selector: (row) => row.actions,
  },
];

export default columns;
